import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CreateSectionRequest, Section, SectionApiResponse } from '../models/section.model';
import { NavigationContextService } from '../../core/services/navigation-context.service';

@Injectable({
  providedIn: 'root'
})
export class SectionRegistryService {
  private http = inject(HttpClient);
  private navContext = inject(NavigationContextService);
  private apiUrl = `${environment.backofficeApiUrl}/api/v1/sections`;

  /**
   * Get all sections (paginated) - con filtri automatici dal contesto
   */
  getSections(): Observable<SectionApiResponse> {
    const context = this.navContext.getCurrentContext();
    let params = new HttpParams()
      .set('domainType', context.domainType);
    
    return this.http.get<SectionApiResponse>(this.apiUrl, { params });
  }

  /**
   * Get a single section by ID
   */
  getSection(id: string | number): Observable<SectionApiResponse> {
    return this.http.get<SectionApiResponse>(`${this.apiUrl}/${id}`);
  }

  /**
   * Create a new section - con contesto automatico
   */
  createSection(section: CreateSectionRequest): Observable<SectionApiResponse> {
    const context = this.navContext.getCurrentContext();
    const payload = {
      ...section,
      domainType: context.domainType
    };
    console.log('[SectionService] Creating section with context:', payload);
    return this.http.post<SectionApiResponse>(this.apiUrl, payload);
  }

  /**
   * Update an existing section (PUT - full update) - con contesto automatico
   */
  updateSectionPut(id: string | number, section: CreateSectionRequest): Observable<SectionApiResponse> {
    const context = this.navContext.getCurrentContext();
    const payload = {
      ...section,
      domainType: context.domainType
    };
    console.log('[SectionService] Updating section with context:', payload);
    return this.http.put<SectionApiResponse>(`${this.apiUrl}/${id}`, payload);
  }

  /**
   * Delete a section
   */
  deleteSection(id: string | number): Observable<SectionApiResponse> {
    return this.http.delete<SectionApiResponse>(`${this.apiUrl}/${id}`);
  }
}
